const SWIPE_DISTANCE = 20; // in points
const SWIPE_DURATION = 500; // in milliseconds

export default class Swipes {


	// Constructor
	constructor(element, callback) {
		this.element = element;
		this.callback = callback;

		this.active = false;
		this.overButton = false;
		this.offset = { x:0, y:0 };
		this.origin = { x:0, y:0 };
		this.point = { x:0, y:0 };
		this.time = Date.now();

		this.onMouseDown = this.onMouseDown.bind(this);
		this.onMouseMove = this.onMouseMove.bind(this);
		this.onMouseUp = this.onMouseUp.bind(this);
		this.onTouchDown = this.onTouchDown.bind(this);
		this.onTouchMove = this.onTouchMove.bind(this);
		this.onTouchUp = this.onTouchUp.bind(this);

		this.element.addEventListener('mousedown', this.onMouseDown);
		this.element.addEventListener('mousemove', this.onMouseMove);
		this.element.addEventListener('mouseup', this.onMouseUp);
		this.element.addEventListener('mouseleave', this.onMouseUp);
		this.element.addEventListener('touchstart', this.onTouchDown);
		this.element.addEventListener('touchmove', this.onTouchMove);
		this.element.addEventListener('touchend', this.onTouchUp);
		this.element.addEventListener('touchcancel', this.onTouchUp);

	}

	// Event Handlers
	onMouseDown(event) {
		if (event.target.nodeName !== 'A' && event.target.nodeName !== 'BUTTON') {
			this.overButton = false;
			event.preventDefault();
		} else {
			this.overButton = true;
		}
		this.active = true;
		this.point.x = event.pageX - event.currentTarget.offsetLeft;
		this.point.y = event.pageY - event.currentTarget.offsetTop;
		this.origin.x = this.point.x;
		this.origin.y = this.point.y;
		this.time = Date.now();
		this.updateOffset();
	}
	onMouseMove(event) {
		if (this.active) {
			event.preventDefault();
			this.point.x = event.pageX - event.currentTarget.offsetLeft;
			this.point.y = event.pageY - event.currentTarget.offsetTop;
			this.updateOffset();
		}
	}
	onMouseUp(event) {
		if (this.active) {
			if (this.overButton === false) {
				event.preventDefault();
			}
			this.overButton = false;
			this.active = false;
			this.updateOffset();
			this.updateDone();
		}
	}
	onTouchDown(event) {
		if (event.touches.length === 1) {
			if (event.target.nodeName !== 'A' && event.target.nodeName !== 'BUTTON') {
				this.overButton = false;
				event.preventDefault();
			} else {
				this.overButton = true;
			}
			this.active = true;
			this.point.x = event.touches[0].pageX - event.currentTarget.offsetLeft;
			this.point.y = event.touches[0].pageY - event.currentTarget.offsetTop;
			this.origin.x = this.point.x;
			this.origin.y = this.point.y;
			this.time = Date.now();
			this.updateOffset();
		} else {
			this.onTouchUp(event);
		}
	}
	onTouchMove(event) {
		if (this.active && event.touches.length === 1) {
			event.preventDefault();
			this.point.x = event.touches[0].pageX - event.currentTarget.offsetLeft;
			this.point.y = event.touches[0].pageY - event.currentTarget.offsetTop;
			this.updateOffset();
		} else {
			this.onTouchUp(event);
		}
	}
	onTouchUp(event) {
		if (this.active) {
			if (this.overButton === false) {
				event.preventDefault();
			}
			this.overButton = false;
			this.active = false;
			this.updateOffset();
			this.updateDone();
		}
	}


	// Helpers
	updateDone() {
		const deltaTime = Date.now() - this.time;
		if (deltaTime <= SWIPE_DURATION) {
			const angle = Math.atan2(this.offset.y, this.offset.x) * 180 / Math.PI;
			if (angle >= 45 && angle <= 135) {
				if (Math.abs(this.offset.y) >= SWIPE_DISTANCE) {
					this.callback('up');
				}
			} else if (angle >= 135 || angle <= -135) {
				if (Math.abs(this.offset.x) >= SWIPE_DISTANCE) {
					this.callback('right');
				}
			} else if (angle <= -45 && angle >= -135) {
				if (Math.abs(this.offset.y) >= SWIPE_DISTANCE) {
					this.callback('down');
				}
			} else {
				if (Math.abs(this.offset.x) >= SWIPE_DISTANCE) {
					this.callback('left');
				}
			}
		}
	}
	updateOffset() {
		this.offset.x = this.point.x - this.origin.x;
		this.offset.y = this.point.y - this.origin.y;
	}


}
